<template>
  <div>
    <sub-header-component
      :title="getLocalized(contentData, 'title')"
      :description="getLocalized(contentData, 'description')"
    ></sub-header-component>
    <div class="p-6 md:p-[100px]">
      <div class="flex flex-col gap-4 md:gap-[40px]">
        <!-- Computer & Accessories Card -->
        <div
          class="w-full lg:h-full md:rounded-[20px] md:p-[40px] flex flex-col gap-[10px] mx-auto bg-[#F4F4F4]"
          v-for="(item, index) in CAData"
          :key="index"
        >
          <div
            class="w-full h-full flex flex-col gap-4 md:gap-[40px] rounded-[16px]"
          >
            <img
              class="w-full md:h-[600px] object-cover md:rounded-[16px] md:p-[10px] md:gap-[10px]"
              :src="item.image_path"
              alt=""
            />
            <div
              class="flex flex-col gap-[20px] p-4 md:p-0 text-start md:text-center"
            >
              <h1 class="font-bold text-xl md:text-4xl">
                {{ getLocalized(item, "name") }}
              </h1>
              <p class="text-lg md:text-2xl">
                {{ getLocalized(item, "description") }}
              </p>
            </div>
            <!-- <a
            href="https://demo-app.turbotech.com:2010"
            class="text-tbt-blue text-start px-4 md:text-center font-medium text-[16px] md:text-[20px]"
          >
            Shop Now ->
          </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";
import subHeaderComponent from "./subHeaderComponent.vue";
export default {
  components: { subHeaderComponent },
  data() {
    return {
      CAData: [],
      api: process.env.VUE_APP_API_KEY,
      contentData: {},
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    this.fetchComputerAndAccessories();
  },
  methods: {
    async fetchComputerAndAccessories() {
      try {
        this.contentData = await fetchContentSection(11);
        const response = await axios.get(
          this.api + "/api/sub-services/?page=1&page_size=20"
        );
        this.CAData = response.data.items
          .map((item) => ({
            ...item,
            image_path: `${this.api}${item.image_path}`,
          }))
          .filter((item) => item.main_service_id === 5)
          .sort((a, b) => a.display_order - b.display_order);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style></style>
